module.exports = __webpack_public_path__ + "static/media/promote.74da89e8.svg";